<template>
  <div>
    <div class="container" v-if="globals.currentUserInfo">
      <div class="panel panel-default text-left">
        <!-- Only allow password change for MSM and partners -->
        <div
          id="passwordResetContainer"
          v-if="
            globals.currentUserRole < 3 &&
            feature.isEnabled('changePasswordSelf') &&
            globals.isAccessAllowed('LoopOp_Password_ChangePasswordSelf') &&
            globals.isAccessAllowed('LoopOp_Password_ValidatePassword')
          "
        >
          <h2>{{ lang.US0000 }}</h2>
          <button
            type="button"
            class="btn btn-raised dialog-btn-primary"
            @click="showChangePasswordDialog = true"
          >
            {{ lang.US0001 }}
          </button>
        </div>

        <div id="filterSettingsContainer">
          <h2>
            {{ lang.US0002 }}
            <span class="beta-feature-indicator">BETA</span>
          </h2>

          <div class="checkbox" id="cbRememberFilterSettings">
            <label>
              <input
                type="checkbox"
                v-model="rememberFilters"
                @change="(syncFilters = false), clearFilters()"
              />
              <span class="checkbox-material">
                <span class="check"></span>
              </span>
              <span class="text text-black">{{ lang.US0003 }}</span>
            </label>
          </div>
          <b-tooltip
            target="cbRememberFilterSettings"
            boundary="viewport"
            triggers="hover"
            placement="topright"
            :delay="globals.tooltipDelay"
            >{{ lang.US0004 }}</b-tooltip
          >
          <div class="checkbox" id="cbSyncFilterSettings">
            <label>
              <input
                type="checkbox"
                v-model="syncFilters"
                @change="clearSharedFilters()"
                :disabled="!rememberFilters"
              />
              <span class="checkbox-material">
                <span class="check"></span>
              </span>
              <span class="text text-black">{{ lang.US0005 }}</span>
            </label>
          </div>
          <b-tooltip
            target="cbSyncFilterSettings"
            boundary="viewport"
            triggers="hover"
            placement="topright"
            :delay="globals.tooltipDelay"
            >{{ lang.US0006 }}</b-tooltip
          >
          <button
            type="button"
            class="btn btn-raised dialog-btn-primary"
            @click="clearFilters"
            :disabled="!rememberFilters"
          >
            {{ lang.US0007 }}
          </button>
        </div>

        <div
          id="loginAsContainer"
          v-if="
            (globals.operationPermitted('Functions.UserLoginAs.Allow') ||
              globals.currentUserInfo.IsLoggedInAsUser) &&
            feature.isEnabled('loginAs')
          "
        >
          <h2>
            {{ lang.US0008 }}
            <span class="beta-feature-indicator">BETA</span>
          </h2>
          <div
            class="form-group"
            v-if="globals.currentUserInfo.IsLoggedInAsUser"
          >
            <button
              type="button"
              class="btn btn-raised btn-warning"
              @click="leaveLoginAsSession()"
            >
              {{ lang.US0009 }}
            </button>
          </div>
          <div class="form-group" v-else>
            <select2
              id="user-settings-loginAsUser"
              class="form-control"
              v-model="loginAsUserId"
              :width="'300px'"
              :placeholder="lang.US0010"
              :allowClear="true"
            >
              <option></option>
              <option
                v-for="user in userList"
                :key="user.UserId"
                :value="user.UserId"
              >
                {{ user.LastName }}, {{ user.FirstName }} ({{ user.LoginName }})
              </option>
            </select2>
            <button
              type="button"
              class="btn btn-raised dialog-btn-primary"
              :disabled="!loginAsUserId"
              @click="requestLoginAs()"
            >
              {{ lang.US0011 }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <change-password-dialog
      :showDialog="showChangePasswordDialog"
      @dialogClosed="showChangePasswordDialog = false"
    ></change-password-dialog>
  </div>
</template>

<script>
import ChangePasswordDialog from "../components/Tools/Dialogs/ChangePasswordDialog";
import Select2 from "./Tools/Select2";

export default {
  name: "UserSettings",
  components: { Select2, ChangePasswordDialog },
  data() {
    return {
      showChangePasswordDialog: false,
      loginAsUserId: "",
      userList: [],
      lang: {
        US0000: "Password",
        US0001: "Change Password",
        US0002: "Filter",
        US0003: "Remember filter settings",
        US0004: "Tables remember their own filters and sort orders.",
        US0005: "Synchronize filter settings",
        US0006:
          "If possible, filter settings will be synchronized between several components of the application.",
        US0007: "Reset all filters",
        US0008: "Login as",
        US0009: "Leave session",
        US0010: "Please select a user...",
        US0011: "Login",
        US0012: "Login as user failed",
        US0013: "Leaving session failed",
      },
    };
  },
  computed: {
    rememberFilters: {
      get() {
        return this.$store.getters["userSettings/rememberFilters"];
      },
      set(value) {
        this.$store.commit("userSettings/rememberFilters", value);
      },
    },
    syncFilters: {
      get() {
        return this.$store.getters["userSettings/syncFilters"];
      },
      set(value) {
        this.$store.commit("userSettings/syncFilters", value);
      },
    },
  },
  watch: {
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
  },
  mounted() {
    this.globals.getLanguageStrings(this);

    if (this.globals.currentUserRole < 0) {
      this.globals.$on("currentUserInfoReceived", () => {
        this.globals.getUserList((data) => {
          this.userList = data;
        });
      });
    } else if (this.globals.currentUserRole === 1)
      this.globals.getUserList((data) => {
        this.userList = data;
      });
  },
  methods: {
    clearFilters() {
      this.clearSharedFilters();
      this.clearLocalFilters();
    },
    clearSharedFilters() {
      this.$store.commit("sharedFilters/clearAll");
    },
    clearLocalFilters() {
      this.$store.commit("localFilters/clearAll");
    },
    requestLoginAs() {
      if (!this.loginAsUserId) return;

      $.ajax({
        method: "GET",
        url: `api/SecurityUsers/LoginAs/${this.loginAsUserId}`,
        // dataType: "json",
        // contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (data.Error) {
            this.globals.showErrorSnackbar(data.Error);
            console.error(data.Error);
            return;
          }
          this.globals.showSpinner(true);
          this.$nextTick(() => {
            location.reload();
          });
        },
        error: (error) => {
          console.error("Error on GET in requestLoginAs()");
          this.globals.showErrorSnackbar(this.lang.US0012);
        },
      });
    },
    leaveLoginAsSession() {
      $.ajax({
        method: "GET",
        url: "api/SecurityUsers/LogoutAs",
        // dataType: "json",
        // contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (data.Error) {
            this.globals.showErrorSnackbar(data.Error);
            console.error(data.Error);
            return;
          }
          this.globals.showSpinner(true);
          this.$nextTick(() => {
            location.reload();
          });
        },
        error: (error) => {
          console.error("Error on GET in leaveLoginAsSession()");
          this.globals.showErrorSnackbar(this.lang.US0013);
        },
      });
    },
  },
};
</script>

<style scoped>
.container {
  padding-top: 20px;
}
.panel {
  padding: 20px 20px;
  overflow: auto;
  max-height: calc(100vh - 100px);
}

h2 {
  font-weight: 500;
}
.panel > div:first-of-type > h2 {
  margin-top: 0;
}

.checkbox {
  display: inline;
  margin: 10px;
}
.checkbox > label {
  position: relative;
}
.checkbox .text {
  position: relative;
  left: 2px;
}
@supports not (-moz-appearance: none) {
  .checkbox .text {
    top: 2px;
  }
}

#filterSettingsContainer > button {
  display: block;
  margin-top: 20px;
}

#loginAsContainer .form-group {
  margin-top: 15px;
}
#loginAsContainer .btn {
  margin: 0px 10px;
}

.beta-feature-indicator {
  font-size: 12px;
  color: orange;
}
</style>



// WEBPACK FOOTER //
// UserSettings.vue?93bbeb1c